module.exports = __webpack_public_path__ + "img/ic_findjobs_enabled.3906b707.svg";